/**
 * Regex for matching tokens with strings, where tokens are identifiers contained in curly brackets.
 * Matches an optional prefix as first group,
 * the token string with brackets as the second group and
 * an optional suffix as the final third group.
 * Eg: 'icon {{icon}} looks cool' would result in:
 *   $1 = 'icon '
 *   $2 = '{{icon}}'
 *   $3 = ' looks cool'
 * By using matchAll all icons can be extracted from a block of text.
 * Eg: 'a {{b}} c {{d}} e {{f}}' would result in
 *   Match 1: $1: 'a '
 *            $2: '{{b}}'
 *            $3: ' c '
 *   Match 2: $1: ''
 *            $2: '{{d}}'
 *            $3: ' e '
 *   Match 3: $1: ''
 *            $2: '{{f}}'
 *            $3: ''
 * Token blocks get matched for two or more bracktes,
 * Eg: {{icon}}, {{{icon}}} or {{{{icon}}}} are tokens, {notatoken} is not
 */
export const stringInstructionExtractionRegex = /([^{}]*)([{]{2,}[^{}]+[}]{2,})([^{}]*)/g;

/**
 * Sanitizes the $2 result of the string instruction extraction regex by removing leading and trailing curly brackets
 */
export const stringInstructionSanitizerRegex = /{+([^{}]*)}+/g;

export function tryExtractInstruction(string: string): string | null {
  const match = string.matchAll(stringInstructionExtractionRegex).next().value;

  if (!match) {
    return null;
  }

  return match[2].matchAll(stringInstructionSanitizerRegex).next().value[1];
}
